import { Injectable, signal } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable, tap } from 'rxjs';
import { FindFaresResponse } from '../models/fares.model';
import { JourneyServicesDto, JourneyQueryParameters, JourneyDto } from '../models/journeys.model';

@Injectable({ providedIn: 'root' })
export class JourneysService extends BaseApiService {
  // getSingleJourneyFares(request: JourneyQueryParameters): Observable<FindFaresResponse> {
  //   const {
  //     origin,
  //     destination,
  //     adults,
  //     children,
  //     railcards,
  //     outwardDepartureDateTime,
  //     ...queryParams
  //   } = request;

  //   // Mapea /journeys/fares/{origin}/{destination}/{adults}/{children}/{railcards}/{outwardDepartureDateTime}
  //   const endpoint = `/journeys/fares/${origin}/${destination}/${adults}/${children}/${railcards}/${outwardDepartureDateTime}`;
  //   return this.get<FindFaresResponse>(endpoint, queryParams);
  // }

  // getReturnJourneyFares(request: JourneyQueryParameters): Observable<FindFaresResponse> {
  //   const {
  //     origin,
  //     destination,
  //     adults,
  //     children,
  //     railcards,
  //     outwardDepartureDateTime,
  //     returnDepartureDateTime,
  //     ...queryParams
  //   } = request;

  //   // Mapea /journeys/fares/.../{returnDepartureDateTime}
  //   const endpoint = `/journeys/fares/${origin}/${destination}/${adults}/${children}/${railcards}/${outwardDepartureDateTime}/${returnDepartureDateTime}`;
  //   return this.get<FindFaresResponse>(endpoint, queryParams);
  // }

  // getSingleJourneyServices(request: JourneyQueryParameters): Observable<JourneyServicesDto> {
  //   const {
  //     origin,
  //     destination,
  //     adults,
  //     children,
  //     railcards,
  //     outwardDepartureDateTime,
  //     ...queryParams
  //   } = request;

  //   // Mapea /journeys/services/...
  //   const endpoint = `/journeys/services/${origin}/${destination}/${adults}/${children}/${railcards}/${outwardDepartureDateTime}`;
  //   return this.get<JourneyServicesDto>(endpoint, queryParams);
  // }

  // getReturnJourneyServices(request: JourneyQueryParameters): Observable<JourneyServicesDto> {
  //   const {
  //     origin,
  //     destination,
  //     adults,
  //     children,
  //     railcards,
  //     outwardDepartureDateTime,
  //     returnDepartureDateTime,
  //     ...queryParams
  //   } = request;

  //   // Mapea /journeys/services/.../{returnDepartureDateTime}
  //   const endpoint = `/journeys/services/${origin}/${destination}/${adults}/${children}/${railcards}/${outwardDepartureDateTime}/${returnDepartureDateTime}`;
  //   return this.get<JourneyServicesDto>(endpoint, queryParams);
  // }
  public readonly outwardServices = signal<JourneyDto[] | null>(null);
  public readonly returnServices = signal<JourneyDto[] | null>(null);

  getJourneyFares(request: JourneyQueryParameters): Observable<FindFaresResponse> {
    const { endpoint, queryParams } = this._buildJourneyEndpoint('fares', request);

    return this.get<FindFaresResponse>(endpoint, queryParams);
  }

  getJourneyServices(request: JourneyQueryParameters): Observable<JourneyServicesDto> {
    const { endpoint, queryParams } = this._buildJourneyEndpoint('services', request);

    return this.get<JourneyServicesDto>(endpoint, queryParams).pipe(
      tap((journeyService) => {
        this.outwardServices.set(journeyService.outward ?? []);
        this.returnServices.set(journeyService.return ?? []);
      }),
    );
  }

  cleanJourneys() {
    this.outwardServices.set(null);
    this.returnServices.set(null);
  }

  private _buildJourneyEndpoint(
    resource: 'fares' | 'services',
    request: JourneyQueryParameters,
  ): { endpoint: string; queryParams: Record<string, unknown> } {
    const {
      origin,
      destination,
      adults,
      children,
      railcards,
      outwardDepartureDateTime,
      returnDepartureDateTime,
      ...queryParams
    } = request;

    let endpoint = `/journeys/${resource}/${origin}/${destination}/${adults}/${children}/${railcards}/${outwardDepartureDateTime}`;

    if (returnDepartureDateTime) {
      endpoint += `/${returnDepartureDateTime}`;
    }

    return { endpoint, queryParams };
  }
}
